import { useHasPermission } from 'src/hooks/useApiData';
import { useTenantFeatures } from 'src/hooks/useTenantFeatures';
import useSWR from 'swr';
import { payablesRequest } from 'src/content/applications/Payables/api';

export function usePayablesAccess() {
  const features = useTenantFeatures();
  const read = useHasPermission('payables_vendor_admin.read');
  const manage = useHasPermission('payables_vendor_admin.manage');
  const approve = useHasPermission('payables_bill_approve.approve');
  const pay = useHasPermission('payables_pay.pay');
  const permissionLoading = !features.isConfigLoaded || read.isLoading || manage.isLoading || approve.isLoading || pay.isLoading;
  const candidate = !permissionLoading && !features.isConfigFailed && features.enabledModules.includes('PAYABLES') && (read.hasPermission || manage.hasPermission || approve.hasPermission || pay.hasPermission);
  const access = useSWR(candidate ? '/v1/payables/access' : null, () => payablesRequest<{ enabled: boolean }>('GET', '/access'), { shouldRetryOnError: false });
  const isLoading = permissionLoading || (candidate && access.isLoading);
  const enabled = candidate && !access.error && access.data?.enabled === true;
  const canRead = enabled && (read.hasPermission || manage.hasPermission);
  return {
    isLoading,
    canRead,
    canReadBills: enabled && (canRead || approve.hasPermission || pay.hasPermission),
    canManage: canRead && manage.hasPermission,
    canVerify: canRead && manage.hasPermission
  };
}

export function usePaymentsAccess() {
  const features = useTenantFeatures();
  const pay = useHasPermission('payables_pay.pay');
  const audit = useHasPermission('payables_audit_view.read');
  const permissionLoading = !features.isConfigLoaded || pay.isLoading || audit.isLoading;
  const candidate = !permissionLoading && !features.isConfigFailed && features.enabledModules.includes('PAYABLES') && (pay.hasPermission || audit.hasPermission);
  const access = useSWR(candidate ? '/v1/payables/payments/access' : null, () => payablesRequest<{ enabled: boolean }>('GET', '/payments/access'), { shouldRetryOnError: false });
  const enabled = candidate && !access.error && access.data?.enabled === true;
  return { isLoading: permissionLoading || (candidate && access.isLoading), canRead: enabled, canPay: enabled && pay.hasPermission };
}
